import { CloseButton, theme } from '@flos/react-components';
import { Container, Grid, MuiThemeProvider } from '@material-ui/core';
import { useStyles } from './onsa-header.styles';
import { ReactComponent as TdLogo } from './../../assets/images/logo_tif.svg';

declare const window: any;

const OnsaHeader = (): JSX.Element => {
    const classes = useStyles();
    const loggedInUser = window.topContext.user.getLogonUser().name;
    const backLink = `${window.location.origin}/forsikringer/indboforsikring`;
    return (
        <div className={classes.onsaheader} data-testid="headerwrapper">
            <Container fixed>
                <MuiThemeProvider theme={theme}>
                    <Grid container spacing={3}>
                        <Grid item xs={6} className="flos-logo">
                            <a href={backLink} title="Til indboForsikring">
                                <TdLogo width={164} height={41} />
                            </a>
                        </Grid>
                        <Grid item xs={6}>
                            <div className={classes.onsaCloseButton}>
                                <CloseButton onClickEvent={() => (window.location.href = backLink)} />
                            </div>
                            {loggedInUser ? (
                                <div className={classes.onsauserinfo}>
                                    <span data-testid="nameelement">{loggedInUser}</span>
                                    <span>
                                        <flos-icon shape={'lock'} size="20" />
                                    </span>
                                </div>
                            ) : (
                                <></>
                            )}
                        </Grid>
                    </Grid>
                </MuiThemeProvider>
            </Container>
        </div>
    );
};

export { OnsaHeader };
